import React from 'react';
import { ColorValueStrict } from 'fronton-react';
import {
  LinkWithGAClickButton,
  SectionSubTitle,
  Typography,
} from 'common/components';
import { createElementKey } from 'utils';
import {
  CategoryCardBg,
  seasonStartCategoryCardItem,
  seasonStartCategoryCardItems,
  seasonStartCategoryCardItemTextWrapper,
  seasonStartCategoryTitle,
} from './season-start-category-styles';

export type SeasonStartCategoryStructure = {
  img: {
    className?: string;
    srcLd: string;
    srcD: string;
    srcT: string;
    src: string;
  };
  itemList: {
    href: string;
    img: {
      alt: string;
      src: string;
    };
    title: string;
  }[];
  title: string;
  textColor?: ColorValueStrict;
};

type SeasonStartCategoryProps = {
  category: SeasonStartCategoryStructure;
  elementBlock: string;
};

export const SeasonStartCategory: React.FC<SeasonStartCategoryProps> = ({ category, elementBlock }) => (
  <CategoryCardBg {...category.img} >
    <div>
      <SectionSubTitle color={category.textColor} className={seasonStartCategoryTitle} margin="m" >
        {category.title}
      </SectionSubTitle>
    </div>
    <div className={seasonStartCategoryCardItems}>
      {category.itemList.map((item, itemIndex) => (
        <LinkWithGAClickButton
          className={seasonStartCategoryCardItem}
          elementBlock={elementBlock}
          elementName={category.title}
          elementText={item.title}
          href={item.href}
          key={createElementKey('season-start-category-item', itemIndex)}
          title={item.title}>
          <img alt={item.img.alt} src={item.img.src} width={48} height={48} />
          <div className={seasonStartCategoryCardItemTextWrapper}>
            <Typography adaptive={false} variant="s" size="subtitle">
              {item.title}
            </Typography>
          </div>
        </LinkWithGAClickButton>
      ))}
    </div>
  </CategoryCardBg>
);
